module.exports = __webpack_public_path__ + "69b7290a6250eec0d7c4554d93d0c6dd.jpg";